import HomePage from '../pages/HomePage';
import PosFrontlineHomePage from '../pages/PosFrontlineHomePage';
import UsersPage from '../pages/UsersPage';
import InventoryPage from '../pages/InventoryPage';
import ProductBulkUpdatesPage from '../pages/ProductBulkUpdatesPage';
import CheckoutPage from '../pages/CheckoutPage';
import CustomersPage from '../pages/CustomersPage';
import ReturnsPage from '../pages/ReturnsPage';
import BarcodeScannerPage from '../pages/BarcodeScannerPage';
import RefundPage from '../pages/RefundPage';
import PromotionsPage from '../pages/PromotionsPage';
import ActivityLogPage from '../pages/ActivityLogPage';
import StoresPage from '../pages/StoresPage';
import TerminalSetupPage from '../pages/TerminalSetupPage';
import RolesPage from '../pages/RolesPage';
import SettingsPage from '../pages/SettingsPage';
import TransactionsPage from '../pages/TransactionsPage';
import StockTransferPage from '../pages/StockTransferPage';
import InventoryLedgerPage from '../pages/InventoryLedgerPage';
import TillPage from '../pages/TillPage';
import SuppliersPage from '../pages/SuppliersPage';
import PurchaseOrdersPage from '../pages/PurchaseOrdersPage';
import InvoicesPage from '../pages/InvoicesPage';
import B2BOrdersPage from '../pages/B2BOrdersPage';
import B2BInvoicesPage from '../pages/B2BInvoicesPage';
import CategoriesPage from '../pages/CategoriesPage';
import ReturnsToSupplierPage from '../pages/ReturnsToSupplierPage';
import SalesReportPage from '../pages/SalesReportPage';
import TillSessionReportPage from '../pages/TillSessionReportPage';
import StockReportPage from '../pages/StockReportPage';
import InventorySnapshotsPage from '../pages/InventorySnapshotsPage';
import ReturnsToSupplierReportPage from '../pages/ReturnsToSupplierReportPage';
import ApiKeysPage from '../pages/ApiKeysPage';
import WebhooksPage from '../pages/WebhooksPage';
import WorkflowsPage from '../pages/WorkflowsPage';
import SchemaViewerPage from '../pages/SchemaViewerPage';
import DeviceFleetPage from '../pages/DeviceFleetPage';
import StoreSettingsLayout from '../components/stores/StoreSettingsLayout';
import BasicInfoSettings from '../components/stores/BasicInfoSettings';
import LocationSettings from '../components/stores/LocationSettings';
import PaymentSettings from '../components/stores/PaymentSettings';
import TimeSettings from '../components/stores/TimeSettings';
import PrintingSettings from '../components/stores/PrintingSettings';
import OrderingSettings from '../components/stores/OrderingSettings';
import DevicesSettings from '../components/stores/DevicesSettings';
import TyroSettings from '../components/settings/TyroSettings';
import TyroReportsPage from '../pages/TyroReportsPage';
import BudgetManagementPage from '../pages/BudgetManagementPage';
import { APP_PROFILES, ALL_APP_PROFILES, getCurrentAppProfile, isProfileAllowed } from './appProfile';

export { APP_PROFILES, getCurrentAppProfile };

const DEFAULT_AND_FRONTLINE = [APP_PROFILES.DEFAULT, APP_PROFILES.POS_FRONTLINE];
const DEFAULT_ONLY = [APP_PROFILES.DEFAULT];
const FRONTLINE_ROUTE_IDS = new Set([
  'home-frontline',
  'checkout',
  'returns',
  'refund-scan',
  'refund-receipt',
  'customers',
  'transactions',
  'tills',
  'inventory',
  'categories',
  'stores',
  'terminal-setup',
  'b2b-orders',
  'b2b-invoices',
  'store-settings',
]);

export const NAV_GROUP_ORDER = [
  'General',
  'Sales & Customers',
  'Inventory',
  'Store Setup',
  'Users & Access',
  'Business Rules',
  'System & Integrations',
  'Reporting & Logs',
];

export const PROTECTED_MODULES = [
  {
    id: 'home-default',
    path: '/',
    title: 'Dashboard',
    component: HomePage,
    requiredPermissions: [],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'General', label: 'Dashboard', icon: 'FiGrid', order: 10 },
  },
  {
    id: 'home-frontline',
    path: '/',
    title: 'Checkout',
    component: PosFrontlineHomePage,
    requiredPermissions: [],
    profiles: [APP_PROFILES.POS_FRONTLINE],
    showInNav: false,
  },
  {
    id: 'inventory',
    path: '/inventory',
    title: 'Product Inventory',
    component: InventoryPage,
    requiredPermissions: ['products:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Products', icon: 'FiBox', order: 10 },
  },
  {
    id: 'inventory-bulk-updates',
    path: '/inventory/bulk-updates',
    title: 'Product Bulk Updates',
    component: ProductBulkUpdatesPage,
    requiredPermissions: ['products:bulk_update'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Bulk Updates', icon: 'FiUpload', order: 15 },
  },
  {
    id: 'inventory-transfers',
    path: '/inventory/transfers',
    title: 'Stock Transfers',
    component: StockTransferPage,
    requiredPermissions: ['products:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Stock Transfers', icon: 'FiTruck', order: 20 },
  },
  {
    id: 'inventory-ledger',
    path: '/inventory/ledger',
    title: 'Inventory Ledger',
    component: InventoryLedgerPage,
    requiredPermissions: ['products:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Inventory Ledger', icon: 'FiBookOpen', order: 30 },
  },
  {
    id: 'suppliers',
    path: '/suppliers',
    title: 'Suppliers',
    component: SuppliersPage,
    requiredPermissions: ['suppliers:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Suppliers', icon: 'FiUserCheck', order: 40 },
  },
  {
    id: 'purchase-orders',
    path: '/purchase-orders',
    title: 'Purchase Orders',
    component: PurchaseOrdersPage,
    requiredPermissions: ['purchase_orders:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Purchase Orders', icon: 'FiClipboard', order: 50 },
  },
  {
    id: 'invoices',
    path: '/invoices',
    title: 'Invoices',
    component: InvoicesPage,
    requiredPermissions: ['invoices:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Invoices', icon: 'FiFileText', order: 60 },
  },
  {
    id: 'b2b-orders',
    path: '/b2b-orders',
    title: 'B2B Sales Orders',
    component: B2BOrdersPage,
    requiredPermissions: ['b2b_orders:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'B2B Orders', icon: 'FiClipboard', order: 50 },
  },
  {
    id: 'b2b-invoices',
    path: '/b2b-invoices',
    title: 'B2B Invoices',
    component: B2BInvoicesPage,
    requiredPermissions: ['b2b_invoices:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'B2B Invoices', icon: 'FiFileText', order: 60 },
  },
  {
    id: 'returns-to-supplier',
    path: '/returns-to-supplier',
    title: 'Returns to Supplier',
    component: ReturnsToSupplierPage,
    requiredPermissions: ['products:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    visibleWhen: ({ user }) =>
      Boolean(user?.permissions?.includes('products:update') && user?.roles?.some?.((role) => role.name === 'Admin')),
    nav: { group: 'Inventory', label: 'Returns to Supplier', icon: 'FiBox', order: 80 },
  },
  {
    id: 'categories',
    path: '/categories',
    title: 'Categories',
    component: CategoriesPage,
    requiredPermissions: ['categories:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Inventory', label: 'Categories', icon: 'FiLayers', order: 70 },
  },
  {
    id: 'checkout',
    path: '/checkout',
    title: 'Checkout',
    component: CheckoutPage,
    requiredPermissions: ['sales:create'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'Checkout', icon: 'FiShoppingCart', order: 10 },
  },
  {
    id: 'customers',
    path: '/customers',
    title: 'Customers',
    component: CustomersPage,
    requiredPermissions: ['customers:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'Customers', icon: 'FiUsers', order: 30 },
  },
  {
    id: 'users',
    path: '/users',
    title: 'User Management',
    component: UsersPage,
    requiredPermissions: ['users:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Users & Access', label: 'Users', icon: 'FiUsers', order: 10 },
  },
  {
    id: 'returns',
    path: '/returns',
    title: 'Process a Return',
    component: ReturnsPage,
    requiredPermissions: ['refunds:create'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'Returns', icon: 'FiRepeat', order: 20 },
  },
  {
    id: 'refund-scan',
    path: '/refund/scan',
    title: 'Scan Receipt',
    component: BarcodeScannerPage,
    requiredPermissions: ['refunds:create'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: false,
  },
  {
    id: 'refund-receipt',
    path: '/refund/receipt/:receiptNumber',
    title: 'Process Refund',
    component: RefundPage,
    requiredPermissions: ['refunds:create'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: false,
  },
  {
    id: 'promotions',
    path: '/promotions',
    title: 'Promotions',
    component: PromotionsPage,
    requiredPermissions: ['promotions:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    hideForCashier: true,
    nav: { group: 'Business Rules', label: 'Promotions', icon: 'FiTag', order: 10 },
  },
  {
    id: 'history',
    path: '/history',
    title: 'Activity History',
    component: ActivityLogPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'History', icon: 'FiList', order: 10 },
  },
  {
    id: 'stores',
    path: '/stores',
    title: 'Store Management',
    component: StoresPage,
    requiredPermissions: ['stores:read'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Store Setup', label: 'Stores', icon: 'FiHome', order: 10 },
  },
  {
    id: 'roles',
    path: '/roles',
    title: 'Roles & Permissions',
    component: RolesPage,
    requiredPermissions: ['roles:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Users & Access', label: 'Roles & Permissions', icon: 'FiShield', order: 20 },
  },
  {
    id: 'terminal-setup',
    path: '/terminal-setup',
    title: 'Terminal Setup',
    component: TerminalSetupPage,
    requiredPermissions: ['stores:update'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Store Setup', label: 'Terminal Setup', icon: 'FiTerminal', order: 20 },
  },
  {
    id: 'settings',
    path: '/settings',
    title: 'Global Settings',
    component: SettingsPage,
    requiredPermissions: ['settings:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'Settings', icon: 'FiSettings', order: 10 },
  },
  {
    id: 'transactions',
    path: '/transactions',
    title: 'Transactions',
    component: TransactionsPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'Transactions', icon: 'FiDollarSign', order: 40 },
  },
  {
    id: 'sales-report',
    path: '/reports/sales',
    title: 'Sales Report',
    component: SalesReportPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Sales Report', icon: 'FiBarChart2', order: 20 },
  },
  {
    id: 'till-session-report',
    path: '/reports/till-sessions',
    title: 'Till Session Report',
    component: TillSessionReportPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Till Session Report', icon: 'FiList', order: 25 },
  },
  {
    id: 'stock-report',
    path: '/reports/stock',
    title: 'Stock Report',
    component: StockReportPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Stock Report', icon: 'FiArchive', order: 30 },
  },
  {
    id: 'budget-management',
    path: '/budgets',
    title: 'Budget Management',
    component: BudgetManagementPage,
    requiredPermissions: ['budgets:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Budgets', icon: 'FiTrendingUp', order: 35 },
  },
  {
    id: 'inventory-snapshots-report',
    path: '/reports/inventory-snapshots',
    title: 'Inventory Snapshots',
    component: InventorySnapshotsPage,
    requiredPermissions: ['reports:view'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Inventory Snapshots', icon: 'FiDatabase', order: 40 },
  },
  {
    id: 'returns-to-supplier-report',
    path: '/reports/returns-to-supplier',
    title: 'Returns to Supplier Report',
    component: ReturnsToSupplierReportPage,
    requiredPermissions: ['products:read'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    nav: { group: 'Reporting & Logs', label: 'Returns to Supplier Report', icon: 'FiArchive', order: 50 },
  },
  {
    id: 'tills',
    path: '/tills',
    title: 'Till Management',
    component: TillPage,
    requiredPermissions: ['tills:manage'],
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: true,
    nav: { group: 'Sales & Customers', label: 'Till Management', icon: 'FiDollarSign', order: 70 },
  },
  {
    id: 'settings-api-keys',
    path: '/settings/api-keys',
    title: 'API Keys',
    component: ApiKeysPage,
    requiredPermissions: ['settings:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'API Keys', icon: 'FiKey', order: 20 },
  },
  {
    id: 'settings-webhooks',
    path: '/settings/webhooks',
    title: 'Webhooks',
    component: WebhooksPage,
    requiredPermissions: ['settings:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'Webhooks', icon: 'FiGlobe', order: 30 },
  },
  {
    id: 'settings-workflows',
    path: '/settings/workflows',
    title: 'Workflows',
    component: WorkflowsPage,
    requiredPermissions: ['settings:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'Workflows', icon: 'FiShare2', order: 40 },
  },
  {
    id: 'settings-schema-viewer',
    path: '/settings/schema-viewer',
    title: 'Schema Viewer',
    component: SchemaViewerPage,
    requiredPermissions: ['settings:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'Schema Viewer', icon: 'FiCode', order: 50 },
  },
  {
    id: 'settings-device-fleet',
    path: '/settings/devices',
    title: 'Device Fleet',
    component: DeviceFleetPage,
    requiredPermissions: ['devices:manage'],
    profiles: DEFAULT_ONLY,
    showInNav: true,
    webOnly: true,
    nav: { group: 'System & Integrations', label: 'Device Fleet', icon: 'FiSmartphone', order: 60 },
  },
  {
    id: 'store-settings',
    path: '/stores/settings/:id',
    title: 'Store Settings',
    component: StoreSettingsLayout,
    requiredPermissions: ['stores:create', 'stores:update'],
    requireAll: false,
    profiles: DEFAULT_AND_FRONTLINE,
    showInNav: false,
    children: [
      { index: true, component: BasicInfoSettings },
      { path: 'basic', component: BasicInfoSettings },
      { path: 'location', component: LocationSettings },
      { path: 'payments', component: PaymentSettings },
      { path: 'timing', component: TimeSettings },
      { path: 'printing', component: PrintingSettings },
      { path: 'ordering', component: OrderingSettings },
      { path: 'devices', component: DevicesSettings },
      { path: 'tyro', component: TyroSettings },
      { path: 'tyro-reports', component: TyroReportsPage },
    ],
  },
];

const getProfilesForModule = (module) =>
  Array.isArray(module?.profiles) && module.profiles.length > 0 ? module.profiles : ALL_APP_PROFILES;

export const getProtectedModulesForProfile = (profile = getCurrentAppProfile()) =>
  PROTECTED_MODULES.filter((module) => isProfileAllowed(getProfilesForModule(module), profile));

export const getNavModulesForProfile = (profile = getCurrentAppProfile()) =>
  getProtectedModulesForProfile(profile).filter((module) => module.showInNav);

export const getFrontlineExcludedModules = () =>
  PROTECTED_MODULES.filter((module) => !FRONTLINE_ROUTE_IDS.has(module.id)).map((module) => module.id);
